/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {injectIntl} from "react-intl";
import {Select} from "@scuf/common";

class LdiSelector extends React.Component {
    render() {
        const {intl} = this.props
        const options = this.props.ldiNamesAndIds.map(a => {
            return {value: a.value, text: a.key}
        })
        return (
            <Select
                options={options}
                label={intl.formatMessage({id: "multipleLdis.selection.label"})}
                placeholder={intl.formatMessage({id: "multipleLdis.selection.placeholder"})}
                onChange={(data) => this.props.onLdiChange(data)}
                value={this.props.selectedLdiForHDR === -1 ? null : options.find(o => o.value === this.props.selectedLdiForHDR).value}
                error={this.props.getErrorMessage(['ldiId'])}
                fluid
            />
        )
    }

}
export default injectIntl((LdiSelector))